import type { FaireProductEntity } from "../../entity_types/product";

export const p_5rfkswd4g2: FaireProductEntity = {
  token: "p_5rfkswd4g2",
  type: "product",
  name: "Tidings Candle -LIMITED EDITION",
  brandToken: "b_rk82ea6pnc",
  brandName: "Smeli",
  imageUrl:
    "https://cdn.faire.com/fastly/5e436ad70fb98aecea3c103824f69a6502ebabd8e821fa0e13ee907436410d23.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9119dc22bb1a05d763c3ec2c27a85098d14a8fb5e5ba0f4d46a101f55e73c0f1.png",
  ],
  priceDollars: 14,
  description:
    "This is Tidings. It's a 9 oz single wick candle in a black glass vessel, finished with our signature die cut illustrated label.\n\nCinnamon and sugar open into warm butter and golden honey before settling into soft vanilla and cream. Sweet, warm, and softly nostalgic, Tidings feels like decorated cookies on the good plates, ribbon left on the table, and something still baking in the kitchen.\n\nSweet. Warm. Nostalgic.\n\nCinnamon | Sugar | Butter | Honey | Vanilla | Cream\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:03.792Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
